<template>
  <div>
    <el-row v-if="editable" class="xztitlepd">
      <el-button type="primary" @click="editItem()" size="small">新增银行账户</el-button>
    </el-row>
    <panel label="银行账户">
      <data-table
        :table-data="data"
        :columns="columns"
        :isPaginationShow="false"
      />
    </panel>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" v-if="editable">
      <bank-account-edit
        :edit-form.sync="editForm"
        @onSubmit = "saveItem"
        @onCancel= "dialogVisible=false"
      />
    </el-dialog>
  </div>
</template>

<script>
  import DataTable from '../../components/DataTable'
  import Panel from '../../components/Panel'
  import BankAccountEdit from './BankAccountEdit'

  export default {
    name: "BankAccountDataTable",
    data() {
      return {
        dialogVisible: false,
        columns: [
          {
            label: '银行',
            field: 'ba__bank'
          },
          {
            label: '开户行',
            field: 'ba__branch'
          },
          {
            label: '户名',
            field: 'ba__accountName'
          },
          {
            label: '银行账号',
            field: 'ba__accountNo'
          },
          {
            label: '操作',
            opts: [
              {
                label: '修改',
                class: 'el-icon-edit',
                clickHandler: (index, row)=>{
                  this.editItem(index, row)
                }
              },
              {
                label: '删除',
                class: 'el-icon-delete',
                clickHandler: (index, row)=>{
                  this.removeItem(index, row)
                }
              }
            ],
            conditions: this.editable
          }
        ],
        editForm: {

        }
      }
    },
    components: {
      DataTable,
      Panel,
      BankAccountEdit
    },
    props: {
      data: {
        type: Object,
        default: ()=>{
          return {
            data: [],
            count: 0
          }
        }
      },
      editable: {
        type: Boolean,
        default: true
      },
      customerId: {
        type: String,
        default: ''
      }
    },
    computed: {
      dialogTitle() {
        return this.editForm.ba__accountNo ? '编辑银行账户' : '新增银行账户'
      }
    },
    methods: {
      editItem: function (index, row) {
        this.dialogVisible = true
        this.editForm = Object.assign({
          ba__customerId: this.customerId
        },row)
      },
      removeItem: function (index, row) {
        this.$emit('onDelete', row)
      },
      saveItem: function () {
        this.$emit('onUpdate', this.editForm)
        this.dialogVisible = false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/BankAccountDataTable.vue